import { Component } from '@angular/core';

export interface HubCard {
  title: string;
  description: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  readonly hubCards: HubCard[] = [
    {
      title: 'Primeros pasos',
      description: 'Requisitos, conceptos y checklist para empezar con Epago.',
      route: '/getting-started',
      icon: 'rocket_launch',
    },
    {
      title: 'Integración Web',
      description: 'Checkout 1‑click, tarjetas y playground en el navegador.',
      route: '/integration/web/agoraweb',
      icon: 'language',
    },
    {
      title: 'Integración Flutter',
      description: 'SDK y flujos de pago en apps móviles.',
      route: '/integration/flutter/agoraweb',
      icon: 'smartphone',
    },
    {
      title: 'Referencia API',
      description: 'OpenAPI: pedidos, operaciones, pagos y eventos.',
      route: '/api/orders',
      icon: 'menu_book',
    },
  ];
}
